import { createAction } from 'typesafe-actions'

import { AssignTree } from 'src/types'

import { TreeActionTypes } from './types'

type Options = {
  page?: number
  request_agency_ids?: string[]
  request_ids?: string[]
}

export const getTree = createAction(
  TreeActionTypes.GET_TREE,
  action =>
    (options: Options = { page: 1 }) =>
      action({ options })
)

export const getTreeFailure = createAction(
  TreeActionTypes.GET_TREE_FAILURE,
  action => (message: string) => action({ message })
)

export const getTreeSuccess = createAction(
  TreeActionTypes.GET_TREE_SUCCESS,
  action => (trees: AssignTree[]) => action({ trees })
)
